import { TPatchGameComment, TPatchManyComment, TQueryCommentByContest } from '@src/modules'

import { request } from './config'

export const getListComment = (contestId: string, params: TQueryCommentByContest) =>
  request({ url: `contest-comment/${contestId}`, method: 'GET', params })
export const removeContestCommentById = (id: string) => request({ url: `contest-comment/${id}`, method: 'DELETE' })
export const patchGameCommentById = (id: string, data: TPatchGameComment) =>
  request({ url: `contest-comment/${id}`, method: 'PATCH', data })
export const patchManyGameCommentById = (data: TPatchManyComment) =>
  request({ url: 'contest-comment/update-many', method: 'PATCH', data })
export const deleteManyComment = (ids: string[]) =>
  request({ url: 'contest-comment/delete-many', method: 'POST', data: { ids } })
